import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Main from './pages/main'
import Offert from './pages/Offert';
import Realizations from './pages/realizations';
import References from './pages/references';
import Contact from './pages/contact';
import Panel from './pages/adminpanel/panel';
import Realization from './pages/realization';

function App() {
  return (
		<BrowserRouter>
			<Routes>
				<Route path="*" element={<Main />} />
				<Route path="/" element={<Main />} />
				<Route path="/offert" element={<Offert />} />
				<Route path="/realizations" element={<Realizations />} />
				<Route path="/realizations/*" element={<Realizations />} />
				<Route path="/realization" element={<Realization />} />
				<Route path="/realization/:id" element={<Realization />} />
				<Route path="/references" element={<References />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/panel" element={<Panel />} />
				<Route path="/login" element={<Panel />} />
				<Route path="/panel/*" element={<Panel />} />
				references
			</Routes>
		</BrowserRouter>
	);
}

export default App;